function NXProductBag({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4290_2384)">
        <path
          d="M20.5357 6.25006H2.46427C1.55694 6.25006 0.821411 6.9856 0.821411 7.89292V21.0358C0.821411 21.9431 1.55694 22.6786 2.46427 22.6786H20.5357C21.443 22.6786 22.1786 21.9431 22.1786 21.0358V7.89292C22.1786 6.9856 21.443 6.25006 20.5357 6.25006Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.21427 1.32149H14.7857C15.2214 1.32149 15.6393 1.49457 15.9474 1.80267C16.2555 2.11077 16.4286 2.52863 16.4286 2.96434V6.25006H6.57141V2.96434C6.57141 2.52863 6.7445 2.11077 7.05259 1.80267C7.36069 1.49457 7.77855 1.32149 8.21427 1.32149Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 12.0001H17.25"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 16.9286H17.25"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4290_2384">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500061)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXProductBag;
